import { TypeInsightsWithoutUnresolvableLinksResponse } from '@/features/contentful/_generated';

/**
 * Generates the structured data schema for an organization.
 */
export const getOrganizationSchema = () => ({
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Collinson Group',
    url: 'https://www.collinsongroup.com/',
    logo: `${process.env.NEXT_PUBLIC_SITE_URL}/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Fcollinson-logo.7dec744f.png&w=1080&q=75`,
    contactPoint: [
        {
            '@type': 'ContactPoint',
            telephone: '+442037250000',
            contactType: 'Corporate Office',
            areaServed: 'GB',
            availableLanguage: 'English',
        },
        {
            '@type': 'ContactPoint',
            telephone: '+19727350536',
            contactType: 'Corporate Office',
            areaServed: 'US',
            availableLanguage: 'English',
        },
        {
            '@type': 'ContactPoint',
            telephone: '+551140813131',
            contactType: 'Customer Service',
            areaServed: 'BR',
            availableLanguage: 'Portuguese',
        },
    ],
    sameAs: ['https://www.linkedin.com/company/collinson/'],
});

/**
 * Generates a structured data schema for breadcrumbs.
 *
 * @param breadcrumbs - An array of breadcrumb objects, each containing:
 *   - `name`: The name of the breadcrumb.
 *   - `url`: The URL of the breadcrumb.
 *
 * @returns An object representing the breadcrumb schema in accordance with
 *          Schema.org's BreadcrumbList format.
 */
export const getBreadcrumbSchema = (breadcrumbs: { name: string; url: string }[]) => ({
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: breadcrumbs.map((breadcrumb, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        name: breadcrumb.name,
        item: breadcrumb.url,
    })),
});

/**
 * Generates a structured data schema for a news article.
 *
 * @param {Object} params - The parameters for the schema.
 * @param {TypeInsightsWithoutUnresolvableLinksResponse} params.fields - The fields containing article data.
 * @param {Object} params.sys - The system metadata for the article.
 * @returns {Object} The structured data schema for the news article.
 */
export const getArticleSchema = ({
    fields,
    sys,
}: TypeInsightsWithoutUnresolvableLinksResponse) => ({
    '@context': 'https://schema.org',
    '@type': 'NewsArticle',
    headline: fields.title,
    image: `https:${fields.heroimage?.fields.file?.url}?fm=webp`,
    datePublished: new Date(fields.publishedDate).toISOString(),
    dateModified: sys.updatedAt,
    author: [
        {
            '@type': 'Person',
            name: fields.author?.fields.name,
        },
    ],
});
